import { useState, useEffect , useRef} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
// @mui  
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import * as incidentReporteActions from "../../actions/incidentReporteActions";

import AccessDenied from '../common/AccessDenied';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const LeadDashboard = (props) => {
  const { actions, leadsData, usersData, sourceData, getUserModuleData, masterProfileData, leadStatusData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  //   const [allLeads, setAllLeads] = useState([]);


  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [getSelectedLeadStatus, setSelectedLeadStatus] = useState([]);
  const [getSelectedLeadProfile, setSelectedLeadProfile] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  //   const [allLeadSource, setAllLeadSource] = useState([]);


  const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  //   const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [legalFormId, setLegalFormId] = useState('person');

  const [userRoleType, setUserRoleType] = useState('');
  const [loggeInUserID, setLoggeInUserID] = useState('');

  const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
  const [isCamChecked, setIsCamChecked] = useState(false);
  const [allLeadFlow, setAllLeadFlow] = useState([]);
  const [totalRowsLead, setTotalRowsLead] = useState(0);
  const [pageSizeLeadPage, setPageSizeLeadPage] = useState(config.ITEMS_PER_PAGE);
  const [currentPageLeadPage, setCurrentPageLeadPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [allLeadFlowExcel, setAllLeadFlowExcel] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [keyword, setKeyword] = useState('');
  const [debitDate1, setDebitDate1] = useState('');
  const [emiAmount1, setEmiAmount1] = useState('');
  const [excelFileBtnHide, setExcelFileBtnHide] = useState(false);
  const [noOfLeadsEntered, setNoOfLeadsEntered] = useState(0);
  const [noOfBureauPulled, setNoOfBureauPulled] = useState(0);
  const [noOfAadharOtpDone, setNoOfAadharOtpDone] = useState(0);
  const [noOfBankStatementUploaded, setNoOfBankStatementUploaded] = useState(0);
  const [noOfFIDraftDone, setNoOfFIDraftDone] = useState(0);
  const [noOfFICompletedDone, setNoOfFICompletedDone] = useState(0);
  const [noOfSendToCredit, setNoOfSendToCredit] = useState(0);

  const [noOfCamSubmitted, setNoOfCamSubmitted] = useState(0);
  const [noOfCamApproved, setNoOfCamApproved] = useState(0);
  const [noOfCamRejected, setNoOfCamRejected] = useState(0);

  const [noOfSanctionLetter, setNoOfSanctionLetter] = useState(0);
  const [noOfDeliveryOrder, setNoOfDeliveryOrder] = useState(0);

  const [noOfEnachTried, setNoOfEnachTried] = useState(0);
  const [noOfEnachSuccessful, setNoOfEnachSuccessful] = useState(0);
  const [noOfEnachFailure, setNoOfEnachFailure] = useState(0);
  const [noOfApplicationsSentForSanctionLetterApproval, setNoOfApplicationsSentForSanctionLetterApproval] = useState(0);  

  const [noOfApplicationsApprovedSanctionLetter, setNoOfApplicationsApprovedSanctionLetter] = useState(0);  
  const [allLocations, setAllLocations] = useState([]);
  const [page, setPage] = useState(1);

  const [showList, setShowList] = useState(false);
  const [selectedWidget, setSelectedWidget] = useState('');
  const [isAdvanceSeachVisible, setIsAdvanceSeachVisible] = useState(false);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    Bank_Statements_Uploaded: "Yes",
    FI_Completed_Done: "Yes",
    FI_Draft_Done: "Yes",
    No_Of_Aadhar_OTP_Done: "Yes",
    No_Of_Bureau_Pulled: "Yes",
    No_Of_Cam_Approved: "Yes",
    No_Of_Cam_Rejected: "Yes",
    No_Of_Sanction_Letter:"Yes",
    No_Of_Applications_Sent_For_Sanction_Letter_Approval:"Yes",
    No_Of_Applications_Approved_Sanction_Letter:"Yes",
    No_Of_Delivery_Order:"Yes",
    No_Of_Cam_Submitted: "Yes",
    Send_To_Credit: "Yes",
  });

  
  const targetRef = useRef(null); 
  
  const [filters, setFilters] = useState({
    username: '',
    start_date: '',
    end_date: '',
    user_id :'', 
    user_type :'',
    locations:''
  });

  const handleCheckboxChange = (event) => {
   /* const { value, checked } = event.target; 
    if (checked) {
      // Add value if checked
      setSelectedOptions([...selectedOptions, value]);
    } else {
      // Remove value if unchecked
      setSelectedOptions(selectedOptions.filter((item) => item !== value));
    } */
  };


  const handleSelectChange = (event, key) => {
    const { value } = event.target;
    setSelectedOptions((prevSelections) => ({
      ...prevSelections,
      [key]: value, // Store values by name instead of index
    }));

    // Logging inside a useEffect is better for debugging state updates
    // console.log("Selected Options:", selectedOptions );
  }; 

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const roleName = localStorage.getItem('authUserRoleName');
    if (roleName !== null) {
      setUserRoleType(roleName);
    }
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Leads')?.view_permission;
        setPermissions(permissionsData);
        setViewModulePermissionStatus(hasViewPermissions);
        setUserHasPermission(hasViewPermissions);

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
          setUserRoleType(result.data.user_info[0].role_type);
          // alert(result.data.user_info[0].role_type);
          setLoggeInUserID(result.data.user_info[0].user_id);

          if (result.data.user_info[0].role_type.toLowerCase() === "credit head") {
            setIsCamChecked(true);
          }

        }

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'is_external_user') && result.data.user_info[0].is_external_user !== '' && result.data.user_info[0].is_external_user === "1") {
          setIsExternalUser(true);
        }

        const hasViewUPIPermissions = permissionsData.find(permission => permission.module_name === 'UPI Registration')?.view_permission;
        setViewUPIModulePermissionStatus(hasViewUPIPermissions);
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });

    console.log("Updated Selected Options:", selectedOptions);

    const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'lead_dashboard'};
    const requestDataMasters = encryptData(objMasters);
    const responseMasters = actions.masterAllData(requestDataMasters, false);
    responseMasters.then((result) => {
        // console.log("Promise resolved -  master profile data:", result); 

          if (result.data.success === 1) {
            const results = result.data.data;
            const locationArrData = results?.all_locations || [];
            setAllLocations(locationArrData); 

        }
    }).catch((error) => {
        // console.log("000000000000000000000 error  = ",error)
    });

  }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID, setIsExternalUser,selectedOptions, setAllLocations]);


  const getOtherDetails = (requestData) => {
    setLoading(true);
    setPreloaderStatus(true);
    setNoOfLeadsEntered(0);
    setNoOfBureauPulled(0);
    setNoOfAadharOtpDone(0);
    setNoOfBankStatementUploaded(0);
    setNoOfFIDraftDone(0);
    setNoOfFICompletedDone(0);
    setNoOfSendToCredit(0);

    setNoOfCamSubmitted(0);
    setNoOfCamApproved(0);
    setNoOfCamRejected(0);
    setNoOfSanctionLetter(0);
    setNoOfDeliveryOrder(0);
    setNoOfApplicationsSentForSanctionLetterApproval(0);
    setNoOfApplicationsApprovedSanctionLetter(0);

    setNoOfEnachTried(0);
    setNoOfEnachSuccessful(0);
    setNoOfEnachFailure(0);
    
    const response = actions.leadFlowOtherDetails(requestData, true);
  
      response.then((result) => {
        setLoading(false);
        setPreloaderStatus(false); 
        if (result?.data?.other_details?.no_of_leads_entered) { 
          setNoOfLeadsEntered(result.data.other_details.no_of_leads_entered);
          } 
          
          if (result?.data?.other_details?.no_of_bureau_pulled) { 
            setNoOfBureauPulled(result.data.other_details.no_of_bureau_pulled);
            } 

            if (result?.data?.other_details?.no_of_aadhar_otp_done) { 
              setNoOfAadharOtpDone(result.data.other_details.no_of_aadhar_otp_done);
              } 
              if (result?.data?.other_details?.no_of_bank_statement_uploaded) { 
                setNoOfBankStatementUploaded(result.data.other_details.no_of_bank_statement_uploaded);
                }
          if (result?.data?.other_details?.no_of_fi_draft_done) { 
            setNoOfFIDraftDone(result.data.other_details.no_of_fi_draft_done);
          } 
          if (result?.data?.other_details?.no_of_fi_completed_done) { 
            setNoOfFICompletedDone(result.data.other_details.no_of_fi_completed_done);
          }
          if (result?.data?.other_details?.no_of_send_to_credit) { 
            setNoOfSendToCredit(result.data.other_details.no_of_send_to_credit);
          }
          
          if (result?.data?.other_details?.no_of_cam_submitted) { 
            setNoOfCamSubmitted(result.data.other_details.no_of_cam_submitted);
          }  

          if (result?.data?.other_details?.no_of_cam_approved) { 
            setNoOfCamApproved(result.data.other_details.no_of_cam_approved);
          } 

          if (result?.data?.other_details?.no_of_cam_rejected) { 
            setNoOfCamRejected(result.data.other_details.no_of_cam_rejected);
          } 

          if (result?.data?.other_details?.no_of_sanction_letter) { 
            setNoOfSanctionLetter(result.data.other_details.no_of_sanction_letter);
          } 

          if (result?.data?.other_details?.no_of_delivery_order) { 
            setNoOfDeliveryOrder(result.data.other_details.no_of_delivery_order);
          } 

          if (result?.data?.other_details?.no_of_applications_sent_for_sanction_letter_approval) { 
            setNoOfApplicationsSentForSanctionLetterApproval(result.data.other_details.no_of_applications_sent_for_sanction_letter_approval);
          }

           if (result?.data?.other_details?.no_of_applications_approved_sanction_letter) { 
            setNoOfApplicationsApprovedSanctionLetter(result.data.other_details.no_of_applications_approved_sanction_letter);
          }

          if (result?.data?.other_details?.no_of_enach_tried) { 
            setNoOfEnachTried(result.data.other_details.no_of_enach_tried);
          } 

          if (result?.data?.other_details?.no_of_enach_successful) { 
            setNoOfEnachSuccessful(result.data.other_details.no_of_enach_successful);
          } 

          if (result?.data?.other_details?.no_of_enach_failure) { 
            setNoOfEnachFailure(result.data.other_details.no_of_enach_failure);
          }  
              
      }).catch((error) => {
        console.error("Promise rejected - lead list:", error);
      });
  }

  const onSubmit = () => {

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 1);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];

    if(filters.start_date ===''){
      filters.start_date = formattedThreeMonthsAgo;
    }

    if(filters.end_date ===''){
      filters.end_date = formattedToday;
    }

    if(filters.user_type ===''){
      filters.user_type = 'individual';
    }

    /*
    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);

    setFilters({
      username:'',
      start_date: formattedThreeMonthsAgo,
      end_date: formattedToday,
      user_id :'', 
      user_type : 'individual',  
    });
 */
  
    setLoading(true);
    setPreloaderStatus(true);
    const params = {
      size: pageSizeLeadPage,
      offsetPage: currentPageLeadPage,
      username: filters.username,
      start_date: filters.start_date,
      end_date: filters.end_date, 
      locations: filters.locations, 
      user_id :filters.user_id, 
      user_type :filters.user_type,    
      selected_widget : selectedWidget,
      requestFrom :'dashboard',
      step :'4',
      "selectedOptions": (isAdvanceSeachVisible) ? selectedOptions   : '',
      "isAdvanceSeachVisible" :isAdvanceSeachVisible   
    };
    
    const requestData = encryptData(params);
    const response = actions.leadFlowReport(requestData, true);
  
    response.then((result) => {
        if (!result.data.data || result.data.data === '') {
        setExcelFileBtnHide(true);
      } else {
        setExcelFileBtnHide(false);
      }
      setPreloaderStatus(false);
      setAllLeadFlow(result.data.data);
      setTotalRowsLead(result.data.total_count);
      getOtherDetails(requestData);
    }).catch((error) => {
      console.error("Promise rejected - lead list:", error);
    });
  };
  
  const handleFilterChange = (data) => {
    setFilters({
      username: data?.username,
      start_date: data?.start_date,
      end_date: data?.end_date,
      locations: data?.locations,
      user_id :data?.user_id, 
      user_type :data?.user_type
    });
    setCurrentPageLeadPage(1);
  };
  
  useEffect(() => {
    onSubmit();
  }, [filters, currentPageLeadPage, pageSizeLeadPage]);
  
  const handlePerRowsChangeLeadPage = (newPageSizeLeadPage, currentPageLeadPage) => {
    setPageSizeLeadPage(newPageSizeLeadPage);
    setCurrentPageLeadPage(currentPageLeadPage);
  };
  
  const handlePageChangeLeadPage = (page) => {
    setCurrentPageLeadPage(page);
  };

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 1);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];

    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);

    setFilters({
      username:'',
      start_date: formattedThreeMonthsAgo,
      end_date: formattedToday,
      locations :'',
      user_id :'', 
      user_type : 'individual',  
    });

    let userRoleTypeVal = userRoleType;
    let isCamCheckedVal = isCamChecked;
    const roleName = localStorage.getItem('authUserRoleName');

    if (roleName !== null) {
      setUserRoleType(roleName);
      userRoleTypeVal = roleName;
      if (roleName.toLowerCase() === "credit head") {
        setIsCamChecked(true);
        isCamCheckedVal = true;
      }
    }

    setShowLeadDetails(false);
    if (!showLeadDetails) {
      const obj = {
        // "user_role_type": userRoleTypeVal ,
        "size": pageSizeLeadPage,
        "offsetPage": currentPageLeadPage,
        "username": filters.username,
        "start_date": formattedThreeMonthsAgo,
        "end_date": formattedToday,
        locations :'', 
        user_id :'', 
        user_type : 'individual', 
        selected_widget : selectedWidget,
        requestFrom :'dashboard',
        step :'1',
        "selectedOptions": (isAdvanceSeachVisible) ? selectedOptions   : '',
        "isAdvanceSeachVisible" :isAdvanceSeachVisible   
      }; 
      const requestData = encryptData(obj);

      getOtherDetails(requestData);

     /* const response = actions.leadFlowReport(requestData);
      response.then((result) => {
        const results = result.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllLeadFlow(resultArr);
        setTotalRowsLead(result.data.total_count);
        setLoading(false)
        getOtherDetails(requestData);
      }) */
    }

    if (Array.isArray(usersData.data)) {
      const extractedData = usersData.data.map(item => {
        return { id: item.user_id, name: item.name };
      });
      const resultArr = Object.values(extractedData);
      setAllUsers(resultArr);
    }

    const objSource = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestSourceData = encryptData(objSource);
    const responseSource = actions.sourceData(requestSourceData, false);
    responseSource.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data
        const filteredResultArr = results.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.source_of_lead.localeCompare(b.source_of_lead)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.source_of_lead };
        });
        const resultArr = Object.values(extractedData);
      }
    }).catch((error) => {
    });

    const objMasterProfile = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestDataMasterProfile = encryptData(objMasterProfile);
    const responseMasterProfile = actions.masterProfileData(requestDataMasterProfile, false);
    responseMasterProfile.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_profile_name.localeCompare(b.lead_profile_name)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_profile_name };
        });
        const extractedObject = Object.values(extractedData);
        setAllMasterProfiles(extractedObject);
      }
    }).catch((error) => {
    });

    const objLeadStatus = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestLeadStatusData = encryptData(objLeadStatus);
    const leadStatusResponse = actions.leadStatusData(requestLeadStatusData);
    leadStatusResponse.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_status.localeCompare(b.lead_status)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_status };
        });
        const extractedObject = Object.values(extractedData);
      }
    }).catch((error) => {
    });
  }, [setAllUsers, setAllMasterProfiles]);

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getLoggedinUserChild(requestData, false);
    response.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const extractedData = results.map(item => {
          return { id: item.user_id, name: item.name };
        });
        const resultArr = Object.values(extractedData);
        setAllLoggedinUserChild(resultArr);
      }
    }).catch((error) => { 
    });
  }, [setAllLoggedinUserChild]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

    const filteredItems = allLeadFlow.filter(item => {
        const name = item.name?.toLowerCase() || '';
          const mobile = item.mobile?.toLowerCase() || '';

        return (
            name.includes(searchQuery.toLowerCase()) ||
             mobile.includes(searchQuery.toLowerCase())
        );
    });

  const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
  const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);

  const checkLogout = () => {
    const authToken = localStorage.getItem('authToken');
    const logInTimestamp = localStorage.getItem('logInTimestamp');

    if (logInTimestamp !== null) {
      const loginTimestamp = parseInt(logInTimestamp, 10);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeElapsed = currentTime - loginTimestamp;
      const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

      if (timeElapsed >= autoLogoutTimeInSecod) {
        const params = { 'login_token': authToken };
        console.log("params : ", params);
        const requestData = encryptData(params);
        const response = actions.userLogout(requestData);
        response.then((result) => {
          if (result.data.success === 1) {
            const data = {};
            actions.loadUserAuth(false);
            actions.loginDataSuccess(data);
            localStorage.setItem("authToken", '');
            localStorage.setItem("logInTimestamp", '');
            navigate("/login");
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  }

  const exportToExcel = () => {
    const totalCount = totalRowsLead;
    if (totalCount > 0) {
      const allDataParams = {
        "size": totalCount,
        "offsetPage": 1,
        selected_widget : selectedWidget,
        requestFrom :'dashboard',
        step :'2',
        "selectedOptions": (isAdvanceSeachVisible) ? selectedOptions   : '',
        "isAdvanceSeachVisible" :isAdvanceSeachVisible       
      };
      const requestData = encryptData(allDataParams);
      const response = actions.leadFlowReport(requestData);
      response.then((result) => {
        if (result.data && result.data.success === 1 && result.data.data) {
          const results = result.data.data;
          if (results && typeof results === 'object') {
            const resultArr = Object.keys(results).map((key) => results[key]);
            const columnNameMapping = {
              lead_id: 'Lead Id',
              applicant_name: 'Applicant Name',
              applicant_number: 'Applicant Number',
              lead_assigned: 'Sales Person Name',
              applicant_aadhar_otp_verified: 'Applicant Aadhar OTP Verified',
              co_applicant_aadhar_otp_verified: 'Co-Applicant Aadhar OTP Verified',
              guarantor_aadhar_otp_verified: 'Guarantor Aadhar OTP Verified',
              bank_statement_upload: 'Bank Statement Upload',
              fi_draft_done: 'FI Draft Done',
              fi_complete_done: 'FI Complete Done',
              cam_complete: 'CAM Complete',
              cam_approved_or_rejected: 'CAM Approved or Rejected',
            };
            const mappedData = resultArr.map((row) => {
              const mappedRow = {};
              Object.keys(row).forEach((key) => {
                if (key !== 'lead_id' && key !== 'total_count') {
                  const displayName = columnNameMapping[key] || key;
                  mappedRow[displayName] = row[key];
                }
              });
              return mappedRow;
            });
            const ws = XLSX.utils.json_to_sheet(mappedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Lead Dashboard');
            XLSX.writeFile(wb, 'LeadDashboard.xlsx');
          } else {
            console.error("Invalid or empty results object", results);
          }
        } else {
          console.error("No data available for export or response error");
        }
         // getOtherDetails(requestData);
      }).catch((error) => {
        console.error("Error fetching all data for export", error);
      });
    } else {
      console.error("Total count is not available or is 0");
    }
  };

  const clickLeadsCount = (action) => {

    setShowList(true);
    setPageSizeLeadPage(config.ITEMS_PER_PAGE);
   setCurrentPageLeadPage(1);
    setLoading(true);
    setPreloaderStatus(true);
    setSelectedWidget(action);
    const params = {
      size: pageSizeLeadPage,
      offsetPage: currentPageLeadPage,
      username: filters.username,
      start_date: filters.start_date,
      end_date: filters.end_date,
      locations: filters.locations,
      selected_widget : action,
      user_id :filters.user_id, 
      user_type : filters.user_type,
      requestFrom :'dashboard' ,
      step :'3',
      "selectedOptions": (isAdvanceSeachVisible) ? selectedOptions   : '',
      "isAdvanceSeachVisible" :isAdvanceSeachVisible        
    };
    
    const requestData = encryptData(params);
    const response = actions.leadFlowReport(requestData, true);
    targetRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    response.then((result) => {
        if (!result.data.data || result.data.data === '') {
        setExcelFileBtnHide(true);
      } else {
        setExcelFileBtnHide(false);
      }
      setAllLeadFlow(result.data.data);
      setTotalRowsLead(result.data.total_count);
      getOtherDetails(requestData);
     }).catch((error) => {
      console.error("Promise rejected - lead list:", error);
    });
  }

  

  const allTableHead = [
    {
      name: 'S. No.',
      selector: (row, index) => {
        const safeCurrentPage = Number.isInteger(currentPageLeadPage) ? currentPageLeadPage : 1;
        const safeItemsPerPage = Number.isInteger(pageSizeLeadPage) ? pageSizeLeadPage : 10;
        const rowIndex = (safeCurrentPage - 1) * safeItemsPerPage + index + 1;
        return rowIndex;
      },
      sortable: false,
      width: '70px',  
      style: {
        textAlign: 'center',  
      },
    },
    {
      name: 'Applicant Name',
      selector: (row) => row?.applicant_name || '-',
      sortable: true,
    },
    {
      name: 'Applicant Number',
      selector: (row) => row?.applicant_number || '-',
      sortable: true,
      cell: row => (
        <a 
            href={`/dashboard/edit-lead/${btoa(row.lead_id)}`} 
            style={{ textDecoration: 'none', color: 'blue' }} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            {row.applicant_number}
        </a>
    ),
    },
    {
      name: 'Sales Persone Name',
      selector: (row) => row?.lead_assigned || '-',
      sortable: true,
    },
    {
      name: 'Applicant Aadhar OTP Verfified',
      selector: (row) => (
            <>
              { /* row?.applicant_aadhar_otp_verified || '-' */ } 
              {row?.applicantAadharOtpVerifiedDate || '-'}
            </>
          ),
      sortable: true,
    },
    {
      name: 'Co-Applicant Aadhar OTP Verfified',
        selector: (row) => (
            <>
              { /* row?.co_applicant_aadhar_otp_verified || '-' */ } 
              {row?.coApplicantAadharOtpVerifiedDate || '-'}
            </>
          ),
      sortable: true,
    },
    {
      name: 'Guarantor Aadhar OTP Verfified',
        selector: (row) => (
            <>
              { /* row?.guarantor_aadhar_otp_verified || '-' */ } 
              {row?.guarantorAadharOtpVerifiedDate || '-'}
            </>
          ),
      sortable: true,
    },
    {
      name: 'Bank Statement Upload',
       selector: (row) => (
            <>
              { /* row?.bank_statement_upload || '-' */ } 
              {row?.bankStatementUploadDate || '-'}
            </>
          ),
      sortable: true,
    },
    {
      name: 'FI Draft Done',
      selector: (row) => row?.fiDraftDoneDate || '-',
      sortable: true,
    },
    {
      name: 'FI Complete Done',
      selector: (row) => row?.fiCompleteDoneDate || '-',
      sortable: true,
    },
    {
      name: 'CAM Complete',
      selector: (row) => row?.camCompleteDate || '-',
      sortable: true,
    },
    {
      name: 'CAM Approved or Rejected',
      selector: (row) => row?.camApprovedOrRejectedDate || '-',
      sortable: true,
    },

  ];

  return (
    <>
      <Helmet>
        <title> Lead Dashboard </title>
      </Helmet>
      <div id='main-wrap' className='mb-4 ms-4 me-4'>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Lead Dashboard
        </Typography>
        <form onSubmit={handleSubmit(handleFilterChange)}>
          <div id='main-wrap' className='mb-3- filter'>
            <div className='row mx-0'>

              <div className='col d-none'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Username</span>
                    <input type='text' name='username' className='form-control' {...register('username')} />
                  </label>
                </div>
              </div>
               
              <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="created-by">
                            <span>All Users</span>
                            <select
                            name="user_id"
                            className="form-select"
                            {...register('user_id')}
                            >
                            <option value="all">Select User</option>
                            {allLoggedinUserChild.map((option) => (
                                <option value={option.id}>
                                {option.name}
                                </option>
                            ))}
                            </select>
                        </label>
                        {errors.user_id && <span className="required">This field is required.</span>}
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="reporting-user">
                            <span>Type</span>
                            <select name='user_type' className="form-select" {...register('user_type')}>
                            <option value="1">INDIVIDUAL</option>
                            <option value="2">TEAM</option>
                            </select>
                        </label>
                        {errors.user_type && <span className="required">This field is required.</span>}
                    </div>
                </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Start Date</span>
                    <input type='date' name='start_date' className='form-control' {...register('start_date')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>End Date</span>
                    <input type='date' name='end_date' className='form-control' {...register('end_date')} />
                  </label>
                </div>
              </div>

               <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>Locations</span>              
                    <select
                        id='locations'
                        name='locations'
                        className="form-select"
                        {...register('locations')} 
                        >
                        <option value='' >Please Select </option>
                        {
                            allLocations.length > 0 && allLocations.map((option) => (
                            <option value={option.id} >
                                {option.name}
                            </option>
                            ))
                        }
                        </select>
                  </label>
                </div>
              </div>
              
              <div className='col'>
                <div className='form-group mb-2'>
                  <span className='d-block'>&nbsp;</span>
                  <button className='btn btn-primary'>Search</button>

                   
            {preloaderStatus && (
                        <>
                          <div
                            className="spinner-border small-preloader"
                            role="status"
                          >
                            <span className="visually-hidden">
                              {" "}
                              Loading...
                            </span>
                          </div>
                        </>
                      )}

                </div>
                 

                
              </div> 
              <a
                  className="text-blue cursor-pointer d-none"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  href="#"
                  tabIndex={0}
                  onClick={(e) => {
                    e.preventDefault(); // Prevents page reload
                    setIsAdvanceSeachVisible(!isAdvanceSeachVisible);  
                  }} 
                >
                  Advance Search
                </a>
            </div>
          </div>

          {/* Section to Show/Hide */}
          {isAdvanceSeachVisible && (
            <div className="mt--4 p-4 border rounded bg-gray-100"  
            style={{ background: 'rgb(219 255 239)'}}>
              <p>Please select options and click on Search button.</p>

             {/* <div className="mt-4">
              <strong>Selected:</strong> {selectedOptions.length > 0 ? selectedOptions.join(", ") : "None"}
              <p>Selected Values: {JSON.stringify(selectedOptions)}</p>
            </div> */}
               
              <div className='row mx-0'>
                <div className='col d-none'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Leads Entered</span>
                           {/* <input type='checkbox' name='view_all' value='No_Of_Leads_Entered' 
                            checked={selectedOptions.includes('No_Of_Leads_Entered')}
                            onChange={handleCheckboxChange}
                            /> */}
                            <select 
                            name='No_Of_Leads_Entered' 
                            className="form-select" 
                            key="No_Of_Leads_Entered"
                            onChange={(event) => handleSelectChange(event, 'No_Of_Leads_Entered')}
                            >
                               <option value="Yes">Yes</option>
                               <option value="No">No</option>
                            </select>

                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Aadhar OTP Done</span>
                            {/*  <input type='checkbox' name='view_all' value='No_Of_Aadhar_OTP_Done' 
                            checked={selectedOptions.includes('No_Of_Aadhar_OTP_Done')}
                            onChange={handleCheckboxChange}
                            /> */}

                            <select 
                              name='No_Of_Aadhar_OTP_Done' 
                              className="form-select"
                              key="No_Of_Aadhar_OTP_Done"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Aadhar_OTP_Done')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                          </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Bureau Pulled</span>
                            {/*   <input type='checkbox' name='view_all' value='No_Of_Bureau_Pulled' 
                            checked={selectedOptions.includes('No_Of_Bureau_Pulled')}
                            onChange={handleCheckboxChange}
                            /> */}

                            <select 
                              name='No_Of_Bureau_Pulled' 
                              className="form-select" 
                              key="No_Of_Bureau_Pulled"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Bureau_Pulled')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>FI Draft Done</span>
                            
                            {/*    <input type='checkbox' name='view_all' value='FI_Draft_Done' 
                            checked={selectedOptions.includes('FI_Draft_Done')}
                            onChange={handleCheckboxChange}
                            /> */}

                          <select 
                              name='FI_Draft_Done' 
                              className="form-select" 
                              key="FI_Draft_Done"
                              onChange={(event) => handleSelectChange(event, 'FI_Draft_Done')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>FI Completed Done</span>
                            {/*    <input type='checkbox' name='view_all' value='FI_Completed_Done' 
                            checked={selectedOptions.includes('FI_Completed_Done')}
                            onChange={handleCheckboxChange}
                            /> */}

                          <select 
                              name='FI_Completed_Done' 
                              className="form-select" 
                              key="FI_Completed_Done"
                              onChange={(event) => handleSelectChange(event, 'FI_Completed_Done')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>Bank Statements Uploaded</span>
                             {/*   <input type='checkbox' name='view_all' value='Bank_Statements_Uploaded' 
                            checked={selectedOptions.includes('Bank_Statements_Uploaded')}
                            onChange={handleCheckboxChange}
                            /> */}

                          <select 
                              name='Bank_Statements_Uploaded' 
                              className="form-select" 
                              key="Bank_Statements_Uploaded"
                              onChange={(event) => handleSelectChange(event, 'Bank_Statements_Uploaded')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                </div>
                <div className='row mx-0'>

               

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>Send To Credit</span>
                             {/*   <input type='checkbox' name='view_all' value='Send_To_Credit' 
                            checked={selectedOptions.includes('Send_To_Credit')}
                            onChange={handleCheckboxChange}
                            /> */}

                          <select 
                              name='Send_To_Credit' 
                              className="form-select" 
                              key="Send_To_Credit"
                              onChange={(event) => handleSelectChange(event, 'Send_To_Credit')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Cam Submitted</span>
                             {/*   <input type='checkbox' name='view_all' value='No_Of_Cam_Submitted' 
                            checked={selectedOptions.includes('No_Of_Cam_Submitted')}
                            onChange={handleCheckboxChange}
                            /> */}

                          <select 
                              name='No_Of_Cam_Submitted' 
                              className="form-select" 
                              key="No_Of_Cam_Submitted"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Cam_Submitted')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Cam Approved</span>
                             {/*   <input type='checkbox' name='view_all' value='No_Of_Cam_Approved' 
                            checked={selectedOptions.includes('No_Of_Cam_Approved')}
                            onChange={handleCheckboxChange}
                            /> */}

                            <select 
                              name='No_Of_Cam_Approved' 
                              className="form-select" 
                              key="No_Of_Cam_Approved"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Cam_Approved')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Cam Rejected</span>
                             {/*   <input type='checkbox' name='view_all' value='No_Of_Cam_Rejected' 
                            checked={selectedOptions.includes('No_Of_Cam_Rejected')}
                            onChange={handleCheckboxChange}
                            /> */}

                            <select 
                              name='No_Of_Cam_Rejected' 
                              className="form-select" 
                              key="No_Of_Cam_Rejected"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Cam_Rejected')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>

                <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>No Of Sanction Letter</span>
                             {/*   <input type='checkbox' name='view_all' value='No_Of_Sanction_Letter' 
                            checked={selectedOptions.includes('No_Of_Sanction_Letter')}
                            onChange={handleCheckboxChange}
                            /> */}

                            <select 
                              name='No_Of_Sanction_Letter' 
                              className="form-select" 
                              key="No_Of_Sanction_Letter"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Sanction_Letter')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>
                <div className='col'>
                <div className='form-group'>
                        <label htmlFor="keyword">
                            <span>E-NACH</span>
                             
                            <select 
                              name='No_Of_Enach' 
                              className="form-select" 
                              key="No_Of_Enach"
                              onChange={(event) => handleSelectChange(event, 'No_Of_Enach')}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                        </label>
                    </div>
                </div>
             
                </div>

                
               
                           

            </div>
          )}

        </form>

        <div className="row mx-0">
           
            <div className= {selectedWidget ==='No_Of_Leads_Entered' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' } > 
            <div>
              <h5 className="text-lg font-semibold">No Of Leads Entered</h5>
              <p className="text-2xl font-bold">
                <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Leads_Entered')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Leads_Entered');
                    }
                  }}
                >
                  {noOfLeadsEntered}
                </span>
              </p>
            </div>
          </div>
        
        <div className={selectedWidget ==='No_Of_Aadhar_OTP_Done' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' } > 
            <div>
              <h5 className="text-lg font-semibold">No Of Aadhar OTP Done</h5>
              <p className="text-2xl font-bold"> 
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Aadhar_OTP_Done')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Aadhar_OTP_Done');
                    }
                  }}
                >
                  {noOfAadharOtpDone}
                </span>


              </p>
              <span className='text-red'>(Number of cases where all individuals are OTP Validated)</span>
            </div>
          </div>

          <div className={selectedWidget ==='No_Of_Bureau_Pulled' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' } > 
            <div>
              <h5 className="text-lg font-semibold">No Of Bureau Pulled</h5>
              <p className="text-2xl font-bold">
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Bureau_Pulled')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Bureau_Pulled');
                    }
                  }}
                >
                  {noOfBureauPulled}
                </span>
                 </p>
            </div>
          </div>

         
         

          </div>
          
          <div className="row mx-0 mt-2">

            <div className={selectedWidget ==='FI_Draft_Done' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2  d-none' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2  d-none' } > 
              <div>
                <h5 className="text-lg font-semibold">FI Draft Done</h5>
                <p className="text-2xl font-bold"> 

                <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('FI_Draft_Done')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('FI_Draft_Done');
                    }
                  }}
                >
                  {noOfFIDraftDone}
                </span>
                </p>
              </div>
            </div> 

            <div className={selectedWidget ==='FI_Completed_Done' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
              <div>
                <h5 className="text-lg font-semibold">FI Completed Done</h5>
                <p className="text-2xl font-bold"> 

                <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('FI_Completed_Done')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('FI_Completed_Done');
                    }
                  }}
                >
                  {noOfFICompletedDone}
                </span>
                </p>
              </div>
            </div>

            <div className={selectedWidget ==='Bank_Statements_Uploaded' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
              <div>
                <h5 className="text-lg font-semibold">Bank Statements Uploaded</h5>
                <p className="text-2xl font-bold"> 

                <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('Bank_Statements_Uploaded')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('Bank_Statements_Uploaded');
                    }
                  }}
                >
                  {noOfBankStatementUploaded}
                </span>
                </p>
              </div>
            </div>


         

      </div>


      <div className="row mx-0 mt-2">

      <div className={ (selectedWidget ==='No_Of_Enach_Tried' || selectedWidget ==='No_Of_Enach_Successful' || selectedWidget ==='No_Of_Enach_Failure') ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              <h5 className="text-lg font-semibold">E-NACH</h5>
              <p className="text-2xl font-bold"> 

              Tried - <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Enach_Tried')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Enach_Tried');
                    }
                  }}
                >
                  {noOfEnachTried}
                </span>
                <br />    
                Successful - <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Enach_Successful')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Enach_Successful');
                    }
                  }}
                >
                  {noOfEnachSuccessful}
                </span>
                
                <br />    
                Failure - <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Enach_Failure')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Enach_Failure');
                    }
                  }}
                >
                  {noOfEnachFailure}
                </span>

              </p>
            </div>
          </div>

      <div className={selectedWidget ==='Send_To_Credit' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2 d-none' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2  d-none' }> 
              <div>
                <h5 className="text-lg font-semibold">Send To Credit</h5>
                <p className="text-2xl font-bold"> 

                <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('Send_To_Credit')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('Send_To_Credit');
                    }
                  }}
                >
                  {noOfSendToCredit}
                </span>
                </p>
              </div>
            </div>

            <div className={selectedWidget ==='No_Of_Cam_Submitted' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Submitted</h5>
              <p className="text-2xl font-bold"> 
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Cam_Submitted')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Cam_Submitted');
                    }
                  }}
                >
                  {noOfCamSubmitted}
                </span>

              </p>
            </div>
          </div> 

            </div>
            <div className="row mx-0 mt-2">

         

          <div className={selectedWidget ==='No_Of_Cam_Approved' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Approved</h5>
              <p className="text-2xl font-bold"> 
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Cam_Approved')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Cam_Approved');
                    }
                  }}
                >
                  {noOfCamApproved}
                </span>

              </p>
            </div>
          </div>

          <div className={selectedWidget ==='No_Of_Cam_Rejected' ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Rejected</h5>
              <p className="text-2xl font-bold"> 

              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Cam_Rejected')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Cam_Rejected');
                    }
                  }}
                >
                  {noOfCamRejected}
                </span>
              </p>
            </div>
          </div>

          <div className={(selectedWidget ==='No_Of_Sanction_Letter' || selectedWidget ==='No_Of_Applications_Sent_For_Sanction_Letter_Approval' || selectedWidget ==='No_Of_Applications_Approved_Sanction_Letter') ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              <h5 className="text-lg font-semibold">Sanction Letter</h5>


              <p className="text-2xl font-bold"> 
              No Of Applications Sent For Approval -   
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Applications_Sent_For_Sanction_Letter_Approval')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Applications_Sent_For_Sanction_Letter_Approval');
                    }
                  }}
                >
                  {noOfApplicationsSentForSanctionLetterApproval}
                </span>
              </p>

              <p className="text-2xl font-bold"> 
              No Of Applications Approved -   
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Applications_Approved_Sanction_Letter')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Applications_Approved_Sanction_Letter');
                    }
                  }}
                >
                  {noOfApplicationsApprovedSanctionLetter}
                </span>
              </p>


              <p className="text-2xl font-bold"> 
              No Of SL Generated -   
              <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Sanction_Letter')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Sanction_Letter');
                    }
                  }}
                >
                  {noOfSanctionLetter}
                </span>
              </p>
 
            </div>
          </div>


            <div className={(selectedWidget ==='No_Of_Delivery_Order' || selectedWidget ==='No_Of_Sanction_Letter_Generated') ? 'col bg-warning shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' : 'col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2' }> 
            <div>
              
              <h5 className="text-lg font-semibold">Delivery Order</h5>
              <p className="text-lg font-semibold">No Of SL Generated -   <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Sanction_Letter_Generated')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Sanction_Letter_Generated');
                    }
                  }}
                >
                  {noOfSanctionLetter}
                </span></p>


                 <p className="text-lg font-semibold">No Of DO Generated -  <span
                  className="text-blue cursor-pointer"
                  role="button"
                  style={{ textDecoration: 'none', color: 'blue' }} 
                  tabIndex={0}
                  onClick={() => clickLeadsCount('No_Of_Delivery_Order')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      clickLeadsCount('No_Of_Delivery_Order');
                    }
                  }}
                >
                  {noOfDeliveryOrder}
                </span></p>
              
            </div>
          </div>




          </div> 


          
      </div>


      { showList && (
        <>
      <Container  ref={targetRef}>
        <div id='main-wrap' className='mb-4'>
          {!excelFileBtnHide ? (
          <div className="col-md-12 d-none" style={{ display: 'flex', justifyContent: 'end' }}>
            <div className="col-md-6 text-end" style={{ marginRight: '1rem' }}>
              <div className="form-group mt-2">
                <button className="btn btn-info text-white" onClick={() => exportToExcel()}>Export Excel File</button>
              </div>
            </div>
          </div>
          ) : (
            <p>-</p>
          )}
          <div style={{ width: '100%', overflowY: 'auto' }}>
         {/*   <DataTable
              columns={allTableHead}
              data={allLeadFlow}
              pagination
              paginationServer
              paginationTotalRows={totalRowsLead}
              paginationPerPage={pageSizeLeadPage}
              paginationDefaultPage={currentPageLeadPage}
              onChangePage={handlePageChangeLeadPage}
              onChangeRowsPerPage={handlePerRowsChangeLeadPage}
            /> */ } 
          </div>

          
            <div className='row justify-content-between'>
                        <div className='col-md-8'>
                            <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                                All Leads
                            </Typography>
                        </div>
                        <div className='col-md-4 pe-0 ps-lg-5'>
                            <div className="form-group">

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Status, Name . . . . "
                                    id="search"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />

                            </div>
                        </div>
                    </div>
            <div className='table-wrap  table-responsive'>

<table border="1" className="table table-hover">
  <thead>
    <tr>
      <th>User Name</th>
      <th>Lead Name</th>	
      <th>Applicant Type</th>	
      <th>Mobile number</th>	
      <th>Add lead</th>	
      <th>Scorecard Creation</th>	
      <th>Scorecard Completion</th>	
      <th>Scorecard Completion- TAT</th>	
      <th>Bureau Pull </th>	
      <th>Bureau Pull- TAT </th>	
      <th>FI Completion </th>	
      <th>FI Completion- TAT </th>

      <th>Sent to Credit</th>	
      <th>Sent to Credit- TAT</th>	
      <th>Sent for Approval</th>	
      <th>Sent for Approval- TAT</th>	
      <th>Approve/ Reject</th>	
      <th>Final Decision- TAT</th>	
      <th>SL Approved</th>	
      <th>SL Approved- TAT</th>
      <th>SL sent to Customer</th>	
      <th>SL sent to Customer- TAT</th>
    </tr>
  </thead>
  <tbody>
    {paginatedItems.map((item, index) =>
      item.applicants.map((applicant, i) => (
        <tr key={`${index}-${i}`}>
          {i === 0 && (
            <td rowSpan={item.applicants.length}>
                 {applicant.createdByName}&nbsp;
            </td>
          )}
            <td>
             { applicant.type === 'Borrower' ? (
                 <>
                   <NavLink to={`/dashboard/edit-lead/${btoa(String(applicant.id))}`} style={{color: "black"}} target="_blank" rel="noopener noreferrer">{applicant.name}</NavLink>
                </>
             )
             : (
                <>
                 {applicant.name}
                </>
             )
            }  
           &nbsp;
            </td>	
            <td>{applicant.type}&nbsp;</td>	
            <td>{applicant.mobile}&nbsp;</td>	
            <td>{applicant.lead_creation}&nbsp;</td>	
            <td>{applicant.lead_creation}&nbsp;</td>	
            <td>{applicant.sales_score_card_completion}&nbsp;</td>	
            <td>{applicant.ScorecardCompletionTAT} {applicant.ScorecardCompletionTAT>1 ? 'Minutes': (applicant.ScorecardCompletionTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>	
            <td>{applicant.BureauPullDateFormatted}&nbsp;</td>	
            <td>{applicant.BureauPullTAT} {applicant.BureauPullTAT>1 ? 'Minutes': (applicant.BureauPullTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>	
            <td>{applicant.FICompleteDatFormatted} &nbsp;</td>	
            <td>{applicant.FICompletionTAT} {applicant.FICompletionTAT>1 ? 'Minutes': (applicant.FICompletionTAT !== ''  ? 'Minute' : '' )} &nbsp;</td>
            {i === 0 && (
                <>
                    <td rowSpan={item.applicants.length}>{applicant.SentToCreditFormatted}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SentToCreditTAT} {applicant.SentToCreditTAT>1 ? 'Minutes': (applicant.SentToCreditTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SentforCAMApprovalFormatted}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SentForApprovalTAT} {applicant.SentForApprovalTAT>1 ? 'Minutes': (applicant.SentForApprovalTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SentforCAMApprovedORRejectFormatted}&nbsp;</td>	  
                    <td rowSpan={item.applicants.length}>{applicant.SentforCAMApprovedORRejectTAT} {applicant.SentforCAMApprovedORRejectTAT>1 ? 'Minutes': (applicant.SentforCAMApprovedORRejectTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SLApprovedFormatted}&nbsp;</td>	

                     <td rowSpan={item.applicants.length}>{applicant.SLApprovedTAT} {applicant.SLApprovedTAT>1 ? 'Minutes': (applicant.SLApprovedTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>
                    <td rowSpan={item.applicants.length}>{applicant.SLSentToCustomerFormatted}&nbsp;</td>	
                    <td rowSpan={item.applicants.length}>{applicant.SLSentToCustomerTAT} {applicant.SLSentToCustomerTAT>1 ? 'Minutes': (applicant.SLSentToCustomerTAT !== ''  ? 'Minute' : '' )}&nbsp;</td>
                </>
             )} 
        </tr>
      ))
    )}

    {paginatedItems.length < 1 && (
        <>
            <tr>
                <td colSpan={21} className='text-center py-3 fw-bold'>No record found</td>
            </tr>
        </>
    )}
  </tbody>
</table>

<div>&nbsp;</div>

                      
                    </div>
                    <div>
                        <nav className='mb-1'>
                            <ul className="pagination pagination-md justify-content-end">
                                {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                                    <li className="page-item">
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            disabled={currentPage === page}
                                            className="page-link"
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
        </div>
      </Container>
      </>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    // leadsData: state.leadsData,
    usersData: state.usersData,
    // sourceData: state.sourceData,
    getUserModuleData: state.getUserModuleData,
    masterProfileData: state.masterProfileData,
    // leadStatusData: state.leadStatusData,
    getLoggedinUserChild: state.getLoggedinUserChild,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default), dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadDashboard);